import React from 'react';
import BlueCallToAction from '../components/common/BlueCallToAction';

/**
 * ProductPage component for the Healthcare AI Platform
 * Displays product features and details
 */
const ProductPage = () => {
  return (
    <div className="product-page">
      <section className="bg-primary-50 dark:bg-gray-800 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 dark:text-white">
            Our AI Platform
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl">
            Discover how our AI-powered platform can transform your healthcare practice with advanced features and seamless integration.
          </p>
        </div>
      </section>
      
      <section className="py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-8 text-gray-900 dark:text-white">
            Product Features Coming Soon
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            We're currently building this page. Check back soon for detailed information about our product features and integration options.
          </p>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <BlueCallToAction 
        heading="Ready to get started with Agent Nexus?"
        description="Experience the power of intelligent automation for your organization."
        primaryButtonText="Request Demo"
        primaryButtonLink="/demo"
        secondaryButtonText="Contact Us"
        secondaryButtonLink="/contact"
      />
    </div>
  );
};

export default ProductPage; 
